import React from "react";
import './Dashboard.css'; 
import { SelectCard } from './../../components/index'
import softwareIcon from './../../assets/svg/software.svg'
import firmwareIcon from './../../assets/svg/firmware.svg'


export default function Dashboard() {
  return (
    <div className="dashboard">
      <h2>Select an Option</h2>
      <div className="cards">
        <SelectCard 
          img={softwareIcon}
          title="Software"
          url="/software"
          />
        <SelectCard 
          img={firmwareIcon}
          title="Firmware"
          url="/firmware"
        />
      </div>
    </div>
    
  )
}
















